"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const toolkit_1 = require("@reduxjs/toolkit");
const stockpile_pos_types_1 = require("./stockpile-pos.types");
const initialState = {
    isError: false,
    isLoading: true,
    errorCode: 0,
    errorMessage: '',
    deviceData: [],
    // hasSelectedAPos:false,
    countDataTransaction: 0,
    TransactionDataStockpile: [],
    configurationCheckPointData: {
        id: '',
        type: '',
        brand1_id: '',
        brand2_id: '',
        brand3_id: '',
        brand4_id: '',
        brand5_id: '',
        brand1_name: '',
        brand2_name: '',
        brand3_name: '',
        brand4_name: '',
        brand5_name: '',
        brand1_color: '',
        brand2_color: '',
        brand3_color: '',
        brand4_color: '',
        brand5_color: '',
        dumping_type: '',
        checkpoint_id: '',
        checkpoint_name: '',
        dumping_type_id: '',
    }
};
const stockpilePosReducer = (0, toolkit_1.createReducer)(initialState, {
    [stockpile_pos_types_1.stockpilePosTypes.GET_LANDING_PAGE_DATA_STOCKPILE]: (state, action) => {
        const { DeviceData, countDataTransaction, TransactionDataStockpile, ConfigurationCheckPointData, } = action.payload;
        return Object.assign(Object.assign({}, state), { isLoading: false, hasSelectedAPos: true, deviceData: DeviceData, countDataTransaction: countDataTransaction, TransactionDataStockpile: TransactionDataStockpile, configurationCheckPointData: ConfigurationCheckPointData });
    },
    [stockpile_pos_types_1.stockpilePosTypes.SET_ERROR]: (state, action) => {
        const { isError, errorCode, errorMessage } = action.payload;
        return Object.assign(Object.assign({}, state), { isError,
            errorCode,
            errorMessage, isLoading: false });
    },
    [stockpile_pos_types_1.stockpilePosTypes.SET_LOADING]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: action.payload.isLoading });
    },
    [stockpile_pos_types_1.stockpilePosTypes.RESET_SELECTED_POS]: (state, action) => {
        return Object.assign(Object.assign({}, state), { hasSelectedAPos: action.payload.hasSelectedAPos });
    }
});
exports.default = stockpilePosReducer;
